module.exports = __webpack_public_path__ + "img/flag_4.9c022602.png";